export default "__VITE_ASSET__BAuZRN6$__"